export const parseDate = (date?: string | null | Date) => {
  if (!date) return new Date();
  if (date instanceof Date) {
    return date;
  } else {
    return new Date(date.replace(/-/g, '/'));
  }
};
